import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css?family=Josefin+Sans');

html {
    font-size: ${props => props.size}px;
}

body {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-family: 'Josefin Sans', sans-serif;
    font-display: fallback;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

@media (min-width: 35em) {
    .react-draggable {
        position: absolute;
    }
}
`;
